import { apiTypeHelper } from '@/base/network'

export const GET_COMPANY_SETTING = apiTypeHelper('GET_COMPANY_SETTING')
export const GET_COMPANY_BODY_INDEX_FIELDS_SETTING = apiTypeHelper('GET_COMPANY_BODY_INDEX_FIELDS_SETTING')